export type OpportunityAmountRange = {
  min?: number;
  max?: number;
};

function parseAmount(raw: string): number {
  const trimmed = raw.trim();
  if (trimmed === "") return NaN;
  return Number(trimmed);
}

/** Parse min/max free-seat filter fields and swap if the user inverted them. */
export function parseOpportunityAmountRange(
  minAmount: string,
  maxAmount: string,
): OpportunityAmountRange {
  const min = parseAmount(minAmount);
  const max = parseAmount(maxAmount);
  const hasMin = Number.isFinite(min);
  const hasMax = Number.isFinite(max);
  if (!hasMin && !hasMax) return {};
  if (hasMin && hasMax) {
    return { min: Math.min(min, max), max: Math.max(min, max) };
  }
  return {
    ...(hasMin ? { min } : {}),
    ...(hasMax ? { max } : {}),
  };
}
